import { retrieveAutomobileBrandsREST } from '../../../common/src/legacy/services/apiRouterService';
import { Campaign } from '../../../../types/Campaigns';
import { AutomobileBrandProps } from '../../../../types/VehicleResponse';

export const getBrandFilter = (campaign?: Campaign): string[] => {
  if (campaign) {
    const { specifications } = campaign;
    return specifications?.car_brand_filters || [];
  }
  return [];
};

export const getBrandNameFilter = async (
  campaign: Campaign,
): Promise<string[] | undefined> => {
  const [resp, status] = await retrieveAutomobileBrandsREST();
  if (status === 200) {
    const { items } = resp;
    return items
      .filter(({ brand }: AutomobileBrandProps) =>
        getBrandFilter(campaign).includes(brand.key),
      )
      .map(({ brand }: AutomobileBrandProps) => brand.name);
  }
};
